export default __webpack_public_path__ + "static/media/winner-child.af45de73.png";